import React from 'react';
import './Footer.css'
import { Box, Grid, Container, Typography } from '@mui/material';
import logo from '../../../images/logo.png'
import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <Box className="footer">
            <Container>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <div className="footer-widget footer-widget-contact aos-init aos-animate" data-aos="fade-up" data-aos-delay="0">
                                <div className="footer-logo">
                                    <img style={{ width: 'auto', height: '50px' }} src={logo} alt="" />
                                </div>
                                <div className="footer-contact">
                                    <p><strong>Language Buddy</strong> is dedicated to teach Chinese language in your native language and provide all the support you need.</p>
                                    <div className="customer-support">
                                        <div className="customer-support-icon">
                                            {/* <img src={support} alt="" /> */}
                                        </div>
                                        <div className="customer-support-text">
                                            <span>Contact Us</span>
                                            <Link className="customer-support-text-phone" to="/">(+860)12345678</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} sx={{ justifyContent: 'center' }}>
                            <div className="footer-widget footer-widget-subscribe aos-init aos-animate" data-aos="fade-up" data-aos-delay="200">
                                <h3 className="footer-widget-title">Subscribe newsletter to get updated</h3>
                                <form action="#" method="post">
                                    <div className="footer-subscribe-box default-search-style d-flex">
                                        <input className="default-search-style-input-box border-around border-right-none subscribe-form" type="email" placeholder="Enter your email" required="" />
                                        <button className="default-search-style-input-btn" type="submit">Subscribe</button>
                                    </div>
                                </form>
                                <p className="footer-widget-subscribe-note">We’ll never share your email address <br /> with a third-party.</p>
                                <ul className="footer-social">
                                    <li><Link to="" className="facebook"><i className="fa fa-facebook"></i></Link></li>
                                    <li><Link to="" className="twitter"><i className="fa fa-twitter"></i></Link></li>
                                    <li><Link to="" className="youtube"><i className="fa fa-youtube"></i></Link></li>
                                    <li><Link to="" className="pinterest"><i className="fa fa-pinterest"></i></Link></li>
                                    <li><Link to="" className="instagram"><i className="fa fa-instagram"></i></Link></li>
                                </ul>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <div className="footer-widget footer-widget-menu" data-aos="fade-up" data-aos-delay="600">
                                <h3 className="footer-widget-title">Quick Links</h3>
                                <div className="footer-menu">
                                    <ul className="footer-menu-nav">
                                        <li><Link to="/">Home</Link></li>
                                        <li><Link to="/about">About Us</Link></li>
                                        <li><Link to="/">Contact us</Link></li>
                                        <li><Link to="/explore">Courses</Link></li>
                                    </ul>
                                    <ul className="footer-menu-nav">
                                        <li><Link to="/">Course Notice</Link></li>
                                        <li><Link to="/">Secure payment</Link></li>
                                        <li><Link to="/">Course Road-map</Link></li>
                                        <li><Link to="/">My Account</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography className="author" sx={{ background: "#66666617", padding: "10px", borderBottom: '3px solid #ddd', textAlign: "center" }}>Copyright © 2021  <Link to="/" >Language Buddy</Link></Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default Footer;


// <div className="footer-section">
//             <div className="footer-contact mt-5 p-5">

//                 <div className="about w-25">
//                     <h3>Language Buddy</h3>
//                     <p>Language Buddy is a complete platform where you can learn, practice and share your thoughts about languages with people around the world.</p>
//                 </div>
//                 {/* contact section  */}
//                 <div className="contact">
//                     <h5>Subscribe to get monthly newsletters</h5>
//                     <Stack direction="horizontal" gap={3}>
//                         <Form.Control className="me-auto" placeholder="your email" />
//                         <Button className="regular-btn">Subscribe</Button>
//                     </Stack>
//                     {/* social links section  */}
//                     <div className="social-link mt-5">
//                         <h5 className=" mb-3">Connect with us on social medias</h5>
//                         <Stack className=" social-icons" direction="horizontal" gap={3}>
//                             <NavLink to="#">
//                                 <i className="fa fa-facebook-square fa-3x"></i>
//                             </NavLink>
//                             <NavLink to="#" >
//                                 <i className="fa fa-twitter-square fa-3x"></i>
//                             </NavLink>
//                             <NavLink to="#">
//                                 <i className="fab fa-google-plus-g fa-3x"></i>
//                             </NavLink>
//                             <NavLink to="#">
//                                 <i className="fab fa-youtube-square fa-3x"></i>
//                             </NavLink>
//                         </Stack>
//                     </div>

//                 </div>

//                 <div className="pages p-5">
//                     <h4>Explore</h4>
//                     <Stack gap={4}>
//                         <NavLink className="route" to="/home">
//                             Home
//                         </NavLink>
//                         <NavLink className="route" to="/about" >
//                             About
//                         </NavLink>
//                         <NavLink className="route" to="/courses">
//                             Courses
//                         </NavLink>
//                         <NavLink className="route" to="/blog">
//                             Blog
//                         </NavLink>
//                     </Stack>
//                 </div>
//             </div>

//             {/* copyright section  */}
//             <div className="copyright-section">
//                 <p>Language Buddy <i className="fa fa-copyright" aria-hidden="true">All Rights Reserved - 2021 |  Made With <i className="fas fa-heart"></i> by Sadman Sakib</i></p>
//             </div>
//         </div>